export default {
  title: "Змінити пароль",
  modal: {
    title: "Змінити пароль",
    form: {
      old_password: {
        label: "Поточний пароль",
        placeholder: "Введіть поточний пароль",
      },
      new_password: {
        label: "Новий пароль",
        placeholder: "Введіть новий пароль",
      },
      repeat_new_password: {
        label: "Повторіть новий пароль",
        placeholder: "Повторіть новий пароль",
      },
      button: {
        close: "Закрити",
        save: "Зберегти"
      },
    },
  },
}
